import axios from 'axios';
import key from '../../../key';


const createProfile = async (userData) => {
    try {
        const response = await axios.post(`${key}/api/user/create-profile`, userData.data, {
            headers: {
                "x-auth-registration": userData.header,
            },
        });
        console.log(response)
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}
const login = async (userData) => {
    try {
        const response = await axios.post(`${key}/api/user/login`, userData);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}
const addImages = async (data) => {
    try {
        const response = await axios.put(`${key}/api/user/addImages`, data.photos, {
            headers: {
                "x-auth-token": data.header,
            },
        });
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}
const deleteImage = async (data) => {
    try {
        const response = await axios.put(`${key}/api/user/delete-image`, data.image, {
            headers: {
                "x-auth-token": data.header,
            },
        });
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}
const recentVisitors = async (data) => {
    try {
        const response = await axios.put(`${key}/api/user/add-recent-visitors`, data.userId, {
            headers: {
                "x-auth-token": data.header,
            },
        });
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}
const whoVisited = async (data) => {
    try {
        const response = await axios.put(`${key}/api/user/add-who-viewed`, data);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

const changePassword = async (data) => {
    try {
        const response = await axios.put(`${key}/api/user/change-password`, data, {
            headers: {
                "x-auth-token": data.header,
            },
        });
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}


const changePreferences = async (data) => {
    try {
        const response = await axios.put(`${key}/api/user/change-preferences`, data, {
            headers: {
                "x-auth-token": data.header,
            },
        });
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

const changePrivacy = async (data) => {
    try {
        const response = await axios.put(`${key}/api/user/change-privacy`, data, {
            headers: {
                "x-auth-token": data.header,
            },
        });
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

const changeVisibility = async (data) => {
    try {
        const response = await axios.put(`${key}/api/user/change-visibility`, data, {
            headers: {
                "x-auth-token": data.header,
            },
        });
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

const changeEmailAlerts = async (data) => {
    try {
        const response = await axios.put(`${key}/api/user/change-email-alerts`, data, {
            headers: {
                "x-auth-token": data.header,
            },
        });
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

const deleteProfile = async (data) => {
    try {
        const response = await axios.delete(`${key}/api/user/delete`, {
            headers: {
                "x-auth-token": data.header,
            },
        });
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

const changePersonalProfile = async (data) => {
    try {
        const response = await axios.put(`${key}/api/user/change-personal-details`, data.dataa, {
            headers: {
                "x-auth-token": data.header,
            },
        });
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}
const onlineStatus = async (data) => {
    try {
        const response = await axios.put(`${key}/api/user/online-status`, data.dataa, {
            headers: {
                "x-auth-token": data.header,
            },
        });
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

const shortListed = async (data) => {
    try {
        const response = await axios.put(`${key}/api/user/add-short-listed`, data.id, {
            headers: {
                "x-auth-token": data.header,
            },
        });
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}
const removeShortlist = async (data) => {
    try {
        const response = await axios.put(`${key}/api/user/remove-short-listed`, data.id, {
            headers: {
                "x-auth-token": data.header,
            },
        });
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

const blocked = async (data) => {
    try {
        const response = await axios.put(`${key}/api/user/add-blocked`, data.id, {
            headers: {
                "x-auth-token": data.header,
            },
        });
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}
const unBlock = async (data) => {
    try {
        const response = await axios.put(`${key}/api/user/un-block`, data.id, {
            headers: {
                "x-auth-token": data.header,
            },
        });
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}
const addLikes = async (data) => {
    try {
        const response = await axios.put(`${key}/api/user/add-connection`, data.id, {
            headers: {
                "x-auth-token": data.header,
            },
        });
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

const addAccepted = async (data) => {
    try {
        const response = await axios.put(`${key}/api/user/accept-request`, data.id, {
            headers: {
                "x-auth-token": data.header,
            },
        });
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}
const addDeclined = async (data) => {
    try {
        const response = await axios.put(`${key}/api/user/reject-request`, data.id, {
            headers: {
                "x-auth-token": data.header,
            },
        });
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}
const getMatches = async (data) => {
    try {
        const response = await axios.put(`${key}/api/user/find-matches`, {
            headers: {
                "x-auth-token": data.header,
            },
        });
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}
const decreaseContact = async (data) => {
    try {
        const response = await axios.put(`${key}/api/user/decrease-contact`,data.data ,{
            headers: {
                "x-auth-token": data.header,
            },
        });
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}



export const userServices = {
    createProfile,
    login,
    addImages,
    changePassword,
    changePreferences,
    changePrivacy,
    changeVisibility,
    deleteProfile,
    changeEmailAlerts,
    changePersonalProfile,
    onlineStatus,
    deleteImage,
    recentVisitors,
    shortListed,
    blocked,
    addLikes,
    addAccepted,
    addDeclined,
    getMatches,
    whoVisited,
    decreaseContact,
    removeShortlist,
    unBlock
}